// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list_questions_exercise-component .stats-container {\n  margin-bottom: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, 38% 8%);\n  gap: 0px; }\n  .list_questions_exercise-component .stats-container p {\n    font-family: var(--font-title);\n    font-weight: 400;\n    font-size: 16px;\n    color: var(--text);\n    margin: 0px;\n    padding: 0px; }\n", ""]);
// Exports
module.exports = exports;
